import AddAdAssetDialog from "readmin_pages/ad_assets/AddAdAsset";
import { AdAssetsDeleteDialog } from "readmin_pages/ad_assets/dialogs";
import AdAssetEditDialog from "readmin_pages/ad_assets/EditDialog";
import AdAssetsPreviewEmailDialog from "readmin_pages/ad_assets/PreviewEmailDialog";
import AddAdPresetDialog from "readmin_pages/ad_presets/AddAdPresetDialog";
import { AdPresetsDeleteDialog } from "readmin_pages/ad_presets/dialogs";
import AdPresetsEditDialog from "readmin_pages/ad_presets/EditDialog";
import UploadAdAssetDialog from "readmin_pages/ad_presets/UploadAdAssetDialog";
import { AiGameStatsRequestReimportDialog } from "readmin_pages/ai_game_stats_requests/dialogs";
import ApiProfileReImportDialog from "readmin_pages/api_profiles/ReImportDialog";
import AddCameraModelDialog from "readmin_pages/camera_models/AddCameraModelDialog";
import CameraModelsEditDialog from "readmin_pages/camera_models/EditDialog";
import AddCameraDialog from "readmin_pages/cameras/AddCameraDialog";
import CamerasEditDialog from "readmin_pages/cameras/EditDialog";
import AddCityDialog from "readmin_pages/cities/AddCityDialog";
import { CitiesEditDialog } from "readmin_pages/cities/EditDialog";
import AddCompetitionDialog from "readmin_pages/competitions/AddCompetitionDialog";
import CompetitionsEditDialog from "readmin_pages/competitions/EditDialog";
import CompetitionsScorekeeperConfigDialog from "readmin_pages/competitions/ScorekeeperConfigDialog";
import AddCourtApiMappingDialog from "readmin_pages/court_api_mappings/AddCourtApiMappingDialog";
import { CourtApiMappingRemoveDialog } from "readmin_pages/court_api_mappings/dialogs";
import AddCourtDialog from "readmin_pages/courts/AddCourtDialog";
import CourtsEditDialog from "readmin_pages/courts/EditDialog";
import EventsDownloadVideoDialog from "readmin_pages/events/DownloadVideoDialog";
import AddGamePersonDialog from "readmin_pages/game_people/AddGamePersonDialog";
import { GamePersonRemoveDialog } from "readmin_pages/game_people/dialogs";
import AddGameScheduleDialog from "readmin_pages/game_schedules/AddGameScheduleDialog";
import GameScheduleAddMissingGameDialog from "readmin_pages/game_schedules/AddMissingGameDialog";
import AddPracticeGameScheduleDialog from "readmin_pages/game_schedules/AddPracticeGameScheduleDialog";
import GameSchedulesEditDialog from "readmin_pages/game_schedules/EditDialog";
import AddGameDialog from "readmin_pages/games/AddGameDialog";
import AddGameRefereeDialog from "readmin_pages/games/AddGameRefereeDialog";
import CutNewFootageDialog from "readmin_pages/games/CutNewFootageDialog";
import {
  GamesDeleteDialog,
  GamesDisablePotwDialog,
  GamesEnablePotwDialog,
  ResendGameNotificationDialog,
} from "readmin_pages/games/dialogs";
import EditGameColoursDialog from "readmin_pages/games/EditGameColoursDialog";
import EditGameScoreDialog from "readmin_pages/games/EditGameScoreDialog";
import GameDownloadScoresheetDialog from "readmin_pages/games/GameDownloadScoresheetDialog";
import AddGdAssociationDialog from "readmin_pages/gd_associations/AddDialog";
import GdAssociationEditDialog from "readmin_pages/gd_associations/EditDialog";
import AddGdVenueDialog from "readmin_pages/gd_venues/AddDialog";
import GdVenueEditDialog from "readmin_pages/gd_venues/EditDialog";
import AddIncidentNoteDialog from "readmin_pages/incident_notes/AddIncidentNoteDialog";
import AddIncidentDialog from "readmin_pages/incidents/AddIncidentDialog";
import { IncidentsRemoveDialog } from "readmin_pages/incidents/dialogs";
import IncidentEditDialog from "readmin_pages/incidents/IncidentEditDialog";
import AddLeagueMemberDialog from "readmin_pages/league_members/AddLeagueMemberDialog";
import { LeagueMembersRemoveDialog } from "readmin_pages/league_members/dialogs";
import AddLeagueTeamDialog from "readmin_pages/league_teams/AddLeagueTeamDialog";
import { LeagueTeamsRemoveDialog } from "readmin_pages/league_teams/dialogs";
import AddLeagueDialog from "readmin_pages/leagues/AddLeagueDialog";
import {
  LeaguesChangeToMiniballDialog,
  LeaguesRemoveAllPlayersFromTeamsDialog,
  LeaguesRestoreTeamsApiRosterDialog,
} from "readmin_pages/leagues/dialogs";
import LeaguesEditDialog from "readmin_pages/leagues/EditDialog";
import LeaguesScorekeeperConfigDialog from "readmin_pages/leagues/ScorekeeperConfigDialog";
import AddLiveStreamCustomOutputDialog from "readmin_pages/live_stream_custom_output/AddLiveStreamCustomOutputDialog";
import { LiveStreamCustomOutputsRemoveDialog } from "readmin_pages/live_stream_custom_output/dialogs";
import LiveStreamCustomOutputsEditDialog from "readmin_pages/live_stream_custom_output/EditDialog";
import AddLiveStreamFbOutputDialog from "readmin_pages/live_stream_fb_output/AddLiveStreamFbOutputDialog";
import { LiveStreamFbOutputsRemoveDialog } from "readmin_pages/live_stream_fb_output/dialogs";
import LiveStreamFbOutputsEditDialog from "readmin_pages/live_stream_fb_output/EditDialog";
import AddLiveStreamScorerDialog from "readmin_pages/live_stream_scorer/AddLiveStreamScorerDialog";
import { LiveStreamScorersRemoveDialog } from "readmin_pages/live_stream_scorer/dialogs";
import LiveStreamScorersEditDialog from "readmin_pages/live_stream_scorer/EditDialog";
import AddLiveStreamYtOutputDialog from "readmin_pages/live_stream_yt_output/AddLiveStreamFbOutputDialog";
import { LiveStreamYtOutputsRemoveDialog } from "readmin_pages/live_stream_yt_output/dialogs";
import AddLiveStreamDialog from "readmin_pages/live_streams/AddLiveStreamDialog";
import LiveStreamsEditDialog from "readmin_pages/live_streams/EditDialog";
import AddMotioncropTestDialog from "readmin_pages/motioncrop_tests/AddMotioncropTestDialog";
import MotioncropTestsEditDialog from "readmin_pages/motioncrop_tests/EditDialog";
import AddNetworkDeviceDialog from "readmin_pages/network_devices/AddNetworkDeviceDialog";
import NetworkDevicesEditDialog from "readmin_pages/network_devices/EditDialog";
import AddOnsenPopupPromoDialog from "readmin_pages/onsen_popup_promos/AddOnsenPopupPromoDialog";
import { OnsenPopupPromosRemoveDialog } from "readmin_pages/onsen_popup_promos/dialogs";
import OnsenPopupPromosEditDialog from "readmin_pages/onsen_popup_promos/EditDialog";
import AddOrgAdminDialog from "readmin_pages/org_admins/AddOrgAdminDialog";
import { OrgAdminsRemoveDialog } from "readmin_pages/org_admins/dialogs";
import OrgAdminsEditDialog from "readmin_pages/org_admins/EditDialog";
import AddOrgDialog from "readmin_pages/orgs/AddOrgDialog";
import { OrgsRefetchFromGameDayDialog } from "readmin_pages/orgs/dialogs";
import OrgsEditDialog from "readmin_pages/orgs/EditDialog";
import ImportCoachReportDialog from "readmin_pages/orgs/ImportCoachReportDialog";
import ImportGameScheduleCsvDialog from "readmin_pages/orgs/ImportGameScheduleCsvDialog";
import AddOriginalVideoRequestDialog from "readmin_pages/original_video_requests/AddOriginalVideoRequestDialog";
import { OriginalVideoRequestsEditDialog } from "readmin_pages/original_video_requests/EditDialog";
import AddPersonDialog from "readmin_pages/people/AddPersonDialog";
import { PeopleSendWelcomeEmailDialog } from "readmin_pages/people/dialogs";
import PeopleEditDialog from "readmin_pages/people/EditDialog";
import PersonGetPlayerPortalLinkDialog from "readmin_pages/people/GetPlayerPortalLinkDialog";
import ImportPeopleDialog from "readmin_pages/people/importPeople";
import ImportRefereeCsvDialog from "readmin_pages/people/ImportRefereeCsvDialog";
import PersonMergeWithOtherDialog from "readmin_pages/people/MergeWithOtherDialog";
import AddPersonSupporterDialog from "readmin_pages/person_supporters/AddPersonSupportDialog";
import PersonSupporterRemoveDialog from "readmin_pages/person_supporters/RemoveDialog";
import PlayHqOrganisationEditDialog from "readmin_pages/play_hq_organisations/EditDialog";
import { PotwEntriesRemoveDialog } from "readmin_pages/potw_entries/dialogs";
import { PotwRatingsRemoveDialog } from "readmin_pages/potw_ratings/dialogs";
import AddPublicLeaguePageDialog from "readmin_pages/public_league_pages/AddPublicLeaguePageDialog";
import PublicLeaguePagesEditDialog from "readmin_pages/public_league_pages/EditDialog";
import AddRecordingBlockExceptionDateDialog from "readmin_pages/recording_block_exception_dates/AddRecordingBlockExceptionDateDialog";
import { RecordingBlockExceptionDateRemoveDialog } from "readmin_pages/recording_block_exception_dates/dialogs";
import AddRecordingBlockDialog from "readmin_pages/recording_blocks/AddRecordingBlockDialog";
import { RecordingBlockRemoveDialog } from "readmin_pages/recording_blocks/dialogs";
import RecordingBlockEditDialog from "readmin_pages/recording_blocks/EditDialog";
import AddScorekeeperUserDialog from "readmin_pages/scorekeeper_users/AddScorekeeperUserDialog";
import { ScorekeeperUsersRemoveDialog } from "readmin_pages/scorekeeper_users/dialogs";
import ScorekeeperUsersEditDialog from "readmin_pages/scorekeeper_users/EditDialog";
import AddSurfaceDialog from "readmin_pages/surfaces/AddSurfaceDialog";
import SurfacesEditDialog from "readmin_pages/surfaces/EditDialog";
import SurfaceEncodingConfigDialog from "readmin_pages/surfaces/EncodingConfigDialog";
import SurfaceFilterConfigDialog from "readmin_pages/surfaces/FilterConfigDialog";
import {
  TeamAddCoachDialog,
  TeamAddPlayerDialog,
  TeamAddSupporterDialog,
} from "readmin_pages/team_members/AddTeamMemberDialogs";
import TeamMemberEditDialog from "readmin_pages/team_members/EditDialog";
import TeamMemberRemoveDialog from "readmin_pages/team_members/RemoveDialog";
import { TeamRegistrationsRemoveDialog, TeamRegistrationsSendDialog } from "readmin_pages/team_registrations/dialogs";
import AddTeamDialog from "readmin_pages/teams/AddTeamDialog";
import { TeamRemoveAllPlayersDialog, TeamsRestoreApiRosterDialog } from "readmin_pages/teams/dialogs";
import TeamsEditDialog from "readmin_pages/teams/EditDialog";
import TeamsEnableRegistrationDialog from "readmin_pages/teams/EnableRegistrationDialog";
import AddUserDialog from "readmin_pages/users/AddUserDialog";
import UserEditDialog from "readmin_pages/users/EditDialog";
import UserResetPasswordDialog from "readmin_pages/users/ResetPasswordDialog";
import AddVenueAdminDialog from "readmin_pages/venue_admins/AddVenueAdminDialog";
import { VenueAdminsRemoveDialog } from "readmin_pages/venue_admins/dialogs";
import VenueAdminsEditDialog from "readmin_pages/venue_admins/EditDialog";
import VenueServerCommandCancelDialog from "readmin_pages/venue_server_commands/CancelDialog";
import { VenueServersCheckIssuesDialog } from "readmin_pages/venue_servers/dialog";
import VenueServersEditDialog from "readmin_pages/venue_servers/EditDialog";
import GenerateVenueServerSshConfigDialog from "readmin_pages/venue_servers/GenerateVenueServerSshConfigDialog";
import VenueServersRunCommandDialog from "readmin_pages/venue_servers/RunCommandDialog";
import AddVenueDialog from "readmin_pages/venues/AddVenueDialog";
import VenuesEditDialog from "readmin_pages/venues/EditDialog";
import { VideoEncodingJobRequestsCancelDialog } from "readmin_pages/video_encoding_job_requests/dialogs";
import {
  VideoVersionsDeleteFootageDialog,
  VideoVersionsDisableDialog,
  VideoVersionsEnableDialog,
} from "readmin_pages/video_versions/dialogs";
import {
  VideosDisableDialog,
  VideosEnableDialog,
  VideosReCutDialog,
  VideosRestoreOriginalVideoDialog,
} from "readmin_pages/videos/dialogs";
import VideoDownloadOriginalVideoDialog from "readmin_pages/videos/DownloadOriginalVideoDialog";
import VideosEditDialog from "readmin_pages/videos/EditDialog";
import VideosReEncodeDialog from "readmin_pages/videos/ReEncodeDialog";

const READMIN_OBJECT_DIALOGS = {
  AdAsset: [AdAssetEditDialog],
  AiGameStatsRequest: [AiGameStatsRequestReimportDialog],
  Surface: [
    //
    SurfaceFilterConfigDialog,
    SurfaceEncodingConfigDialog,
  ],
  League: [
    //
  ],
  Game: [
    EditGameScoreDialog,
    EditGameColoursDialog,
    CutNewFootageDialog,
    AddGameRefereeDialog,
    GameDownloadScoresheetDialog,
  ],
  GamePerson: [GamePersonRemoveDialog],
  Team: [TeamRemoveAllPlayersDialog],
  TeamMember: [TeamMemberEditDialog, TeamMemberRemoveDialog],
  Video: [AddMotioncropTestDialog, VideoDownloadOriginalVideoDialog],
  Incident: [IncidentEditDialog],
  User: [UserEditDialog, UserResetPasswordDialog],
  VenueServerCommand: [VenueServerCommandCancelDialog],
  Person: [PersonGetPlayerPortalLinkDialog, PersonMergeWithOtherDialog, PeopleSendWelcomeEmailDialog],
  PersonSupporter: [PersonSupporterRemoveDialog],
  CourtApiMapping: [CourtApiMappingRemoveDialog],
  GdVenue: [GdVenueEditDialog],
  GdAssociation: [GdAssociationEditDialog],
  PlayHqOrganisation: [PlayHqOrganisationEditDialog],
  ApiProfile: [ApiProfileReImportDialog],
  RecordingBlock: [RecordingBlockEditDialog, RecordingBlockRemoveDialog],
  RecordingBlockExceptionDate: [RecordingBlockExceptionDateRemoveDialog],
  GameSchedule: [GameScheduleAddMissingGameDialog],
};

export const READMIN_OBJECT_BATCH_DIALOGS = {
  AdAsset: [AdAssetsDeleteDialog, AdAssetsPreviewEmailDialog],
  AdPreset: [AdPresetsDeleteDialog, AdPresetsEditDialog, UploadAdAssetDialog],
  Org: [OrgsEditDialog, OrgsRefetchFromGameDayDialog],
  OrgAdmin: [OrgAdminsEditDialog, OrgAdminsRemoveDialog],
  Video: [
    //
    VideosEditDialog,
    VideosReCutDialog,
    VideosReEncodeDialog,
    VideosDisableDialog,
    VideosEnableDialog,
    VideosRestoreOriginalVideoDialog,
  ],
  VideoEncodingJobRequest: [
    //
    VideoEncodingJobRequestsCancelDialog,
  ],
  Incident: [IncidentsRemoveDialog],
  Camera: [CamerasEditDialog],
  CameraModel: [CameraModelsEditDialog],
  City: [CitiesEditDialog],
  Court: [CourtsEditDialog],
  Game: [GamesEnablePotwDialog, GamesDisablePotwDialog, ResendGameNotificationDialog, GamesDeleteDialog],
  VideoVersion: [VideoVersionsDeleteFootageDialog, VideoVersionsDisableDialog, VideoVersionsEnableDialog],
  League: [
    LeaguesEditDialog,
    LeaguesChangeToMiniballDialog,
    LeaguesRemoveAllPlayersFromTeamsDialog,
    LeaguesRestoreTeamsApiRosterDialog,
    LeaguesScorekeeperConfigDialog,
  ],
  LeagueTeam: [LeagueTeamsRemoveDialog],
  LeagueMember: [LeagueMembersRemoveDialog],
  MotioncropTest: [MotioncropTestsEditDialog],
  NetworkDevice: [NetworkDevicesEditDialog],
  VenueAdmin: [VenueAdminsRemoveDialog, VenueAdminsEditDialog],
  VenueServer: [VenueServersEditDialog, VenueServersCheckIssuesDialog, VenueServersRunCommandDialog],
  Venue: [VenuesEditDialog],
  OnsenPopupPromo: [OnsenPopupPromosRemoveDialog, OnsenPopupPromosEditDialog],
  Person: [PeopleEditDialog],
  PotwEntry: [PotwEntriesRemoveDialog],
  PotwRating: [PotwRatingsRemoveDialog],
  PublicLeaguePage: [PublicLeaguePagesEditDialog],
  Team: [TeamsEditDialog, TeamsEnableRegistrationDialog, TeamsRestoreApiRosterDialog],
  TeamRegistration: [TeamRegistrationsSendDialog, TeamRegistrationsRemoveDialog],
  Event: [EventsDownloadVideoDialog],
  ScorekeeperUser: [ScorekeeperUsersEditDialog, ScorekeeperUsersRemoveDialog],
  LiveStream: [LiveStreamsEditDialog],
  LiveStreamCustomOutput: [LiveStreamCustomOutputsRemoveDialog, LiveStreamCustomOutputsEditDialog],
  LiveStreamFbOutput: [LiveStreamFbOutputsEditDialog, LiveStreamFbOutputsRemoveDialog],
  LiveStreamYtOutput: [LiveStreamYtOutputsRemoveDialog],
  LiveStreamScorer: [LiveStreamScorersEditDialog, LiveStreamScorersRemoveDialog],
  OriginalVideoRequest: [OriginalVideoRequestsEditDialog],
  Surface: [SurfacesEditDialog],
  GameSchedule: [GameSchedulesEditDialog],
  Competition: [CompetitionsEditDialog, CompetitionsScorekeeperConfigDialog],
};

export const READMIN_OBJECTS_INDEX_DIALOGS = {
  AdAsset: [AddAdAssetDialog],
  AdPreset: [AddAdPresetDialog],
  GdVenue: [AddGdVenueDialog],
  GdAssociation: [AddGdAssociationDialog],
  Game: [AddGameDialog],
  Camera: [AddCameraDialog],
  CameraModel: [AddCameraModelDialog],
  Org: [AddOrgDialog],
  OrgAdmin: [AddOrgAdminDialog],
  Court: [AddCourtDialog],
  CourtApiMapping: [AddCourtApiMappingDialog],
  City: [AddCityDialog],
  GamePerson: [AddGamePersonDialog],
  MotioncropTest: [AddMotioncropTestDialog],
  NetworkDevice: [AddNetworkDeviceDialog],
  PersonSupporter: [AddPersonSupporterDialog],
  Person: [AddPersonDialog, ImportPeopleDialog, ImportRefereeCsvDialog, ImportCoachReportDialog],
  PublicLeaguePage: [AddPublicLeaguePageDialog],
  Team: [AddTeamDialog],
  TeamMember: [TeamAddCoachDialog, TeamAddPlayerDialog, TeamAddSupporterDialog],
  VenueAdmin: [AddVenueAdminDialog],
  User: [AddUserDialog],
  Incident: [AddIncidentDialog],
  IncidentNote: [AddIncidentNoteDialog],
  OnsenPopupPromo: [AddOnsenPopupPromoDialog],
  VenueServer: [GenerateVenueServerSshConfigDialog],
  Venue: [AddVenueDialog],
  League: [AddLeagueDialog],
  LeagueTeam: [AddLeagueTeamDialog],
  LeagueMember: [AddLeagueMemberDialog],
  RecordingBlock: [AddRecordingBlockDialog],
  RecordingBlockExceptionDate: [AddRecordingBlockExceptionDateDialog],
  ScorekeeperUser: [AddScorekeeperUserDialog],
  LiveStream: [AddLiveStreamDialog],
  LiveStreamCustomOutput: [AddLiveStreamCustomOutputDialog],
  LiveStreamFbOutput: [AddLiveStreamFbOutputDialog],
  LiveStreamYtOutput: [AddLiveStreamYtOutputDialog],
  LiveStreamScorer: [AddLiveStreamScorerDialog],
  Surface: [AddSurfaceDialog],
  OriginalVideoRequest: [AddOriginalVideoRequestDialog],
  GameSchedule: [AddGameScheduleDialog, AddPracticeGameScheduleDialog, ImportGameScheduleCsvDialog],
  Competition: [AddCompetitionDialog],
};

export const READMIN_OBJECT_DIALOG_PARAM_NAMES = {
  AdAsset: "adAssetId",
  AdPreset: "adPresetId",
  AiGameStatsRequest: "aiGameStatsRequestId",
  ApiProfile: "apiProfileId",
  Game: "gameId",
  GamePerson: "gamePersonId",
  Team: "teamId",
  TeamMember: "teamMemberId",
  League: "leagueId",
  Video: "videoId",
  VideoEncodingJobRequest: "videoEncodingJobRequestId",
  VideoEncodingJob: "videoEncodingJobId",
  Incident: "incidentId",
  IncidentNote: "incidentNoteId",
  Camera: "cameraId",
  CameraModel: "cameraModelId",
  City: "cityId",
  Org: "orgId",
  Court: "courtId",
  CourtApiMapping: "courtApiMappingId",
  MotioncropTest: "motioncropTestId",
  User: "userId",
  VenueServer: "venueServerId",
  VenueServerCommand: "venueServerCommandId",
  Venue: "venueId",
  VenueAdmin: "venueAdminId",
  OnsenPopupPromo: "onsenPopupPromoId",
  Person: "personId",
  PersonSupporter: "personSupporterId",
  GdVenue: "gdVenueId",
  GdAssociation: "gdAssociationId",
  PlayHqOrganisation: "playHqOrganisationId",
  Event: "eventId",
  RecordingBlock: "recordingBlockId",
  RecordingBlockExceptionDate: "recordingBlockExceptionDateId",
  ScorekeeperUser: "scorekeeperUserId",
  LiveStream: "liveStreamId",
  LiveStreamCustomOutput: "liveStreamCustomOutputId",
  LiveStreamYtOutput: "liveStreamYtOutputId",
  LiveStreamFbOutput: "liveStreamFbOutputId",
  LiveStreamScorer: "liveStreamScorerId",
  Surface: "surfaceId",
  OriginalVideoRequest: "originalVideoRequestId",
  GameSchedule: "gameScheduleId",
  Competition: "competitionId",
};

export const READMIN_OBJECT_BATCH_DIALOG_PARAM_NAMES = {
  AdAsset: "adAssetIds",
  AdPreset: "adPresetIds",
  Camera: "cameraIds",
  CameraModel: "cameraModelIds",
  Org: "orgIds",
  OrgAdmin: "orgAdminIds",
  City: "cityIds",
  Court: "courtIds",
  Game: "gameIds",
  Video: "videoIds",
  VideoVersion: "videoVersionIds",
  VideoEncodingJobRequest: "videoEncodingJobRequestIds",
  VideoEncodingJob: "videoEncodingJobIds",
  VenueServer: "venueServerIds",
  VenueAdmin: "venueAdminIds",
  Venue: "venueIds",
  OnsenPopupPromo: "onsenPopupPromoIds",
  Person: "personIds",
  PublicLeaguePage: "publicLeaguePageIds",
  PotwEntry: "potwEntryIds",
  PotwRating: "potwRatingIds",
  League: "leagueIds",
  LeagueTeam: "leagueTeamIds",
  LeagueMember: "leagueMemberIds",
  MotioncropTest: "motioncropTestIds",
  NetworkDevice: "networkDeviceIds",
  Team: "teamIds",
  TeamRegistration: "teamRegistrationIds",
  Event: "eventIds",
  ScorekeeperUser: "scorekeeperUserIds",
  Incident: "incidentIds",
  LiveStream: "liveStreamIds",
  LiveStreamCustomOutput: "liveStreamCustomOutputIds",
  LiveStreamYtOutput: "liveStreamYtOutputIds",
  LiveStreamFbOutput: "liveStreamFbOutputIds",
  LiveStreamScorer: "liveStreamScorerIds",
  Surface: "surfaceIds",
  OriginalVideoRequest: "originalVideoRequestIds",
  GameSchedule: "gameScheduleIds",
  Competition: "competitionIds",
};

export default READMIN_OBJECT_DIALOGS;
